import React, { useEffect, useState } from "react";
import { useLoading } from "../Loading";
import { useAuth } from "../../contexts/authContext";
import db from "../../firebase/firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { CFormLabel, CCol, CForm, CFormTextarea, CFormSelect } from '@coreui/react'
import { getAuth, updateProfile } from "firebase/auth";
import { useNavigate } from "react-router-dom";

function ShelterProfile() {
    const { setLoading } = useLoading();
    const { currentUser } = useAuth();
    const auth = getAuth();
    const user = auth.currentUser;
    const navigate = useNavigate();
    const [ShelterData, setShelterData] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [ready, getReady] = useState(false);
    const malaysiaStates = [
        "Johor",
        "Kedah",
        "Kelantan",
        "Malacca",
        "Negeri Sembilan",
        "Pahang",
        "Perak",
        "Perlis",
        "Penang",
        "Sabah",
        "Sarawak",
        "Selangor",
        "Terengganu",
        "Kuala Lumpur",
    ];
    useEffect(() => {
        setLoading(false);
    }, [])



    useEffect(() => {

        if (!currentUser) {
            navigate('/');
            return;
        }

        const fetchShelterInfo = async () => {
            const ShelterRef = doc(db, "Shelters", currentUser.uid);
            const ShelterSnap = await getDoc(ShelterRef);
            if (ShelterSnap.exists()) {
                const ShelterData = ShelterSnap.data();
                setShelterData(ShelterData);
                setLoading(false);
                getReady(true);
            }
        }
        fetchShelterInfo();

    }, [currentUser]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setShelterData((preData) => ({
            ...preData,
            [id]: value
        }));
    };

    const handleEdit = () => {
        setIsEditing(true);
    }

    const handleSave = async () => {

        if (ShelterData.shelterName&&ShelterData.contactPerson && (/^\d{6}-\d{2}-\d{4}$/.test(ShelterData.icNumber)) 
            && ShelterData?.postcode?.length === 5 && (/^\+601\d-\d{7,8}$/.test(ShelterData.phoneNumber)) 
            && ShelterData.address&& ShelterData.city && ShelterData.state) {
            setLoading(true);
            try {
                const ShelterRef = doc(db, "Shelters", currentUser.uid);
                await updateProfile(user, {
                    displayName: ShelterData.shelterName,
                });
                await updateDoc(ShelterRef, ShelterData);
                window.location.reload();
                alert("Profile Updated");
                setIsEditing(false);
                setLoading(false);
            }
            catch (error) {
                console.log(error);
                setLoading(false);
            }
        }
    }

    return (
        <div className="shelterProfileContainer">
            <h1>Shelter Profile</h1>
            {ready &&
                <>
                    <div className="profileDetails">
                        <CForm className="row g-3" >
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputName" className="formLabel">Shelter Name</CFormLabel>
                                <CFormTextarea id="shelterName" value={ShelterData.shelterName} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="1" />
                                {!ShelterData.shelterName && (
                                    <p className="errorMessage">Name cannot be empty</p>
                                )}
                            </CCol>
                           
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputPerson" className="formLabel">Contact Person</CFormLabel>
                                <CFormTextarea id="contactPerson" value={ShelterData.contactPerson} 
                                    onChange={(e) => {
                                        setShelterData(prev => ({ ...prev, contactPerson:  e.target.value }));
                                    }}
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} required rows="1" />
                                {(!ShelterData.contactPerson ) && (
                                    <p className="errorMessage">Contact Person cannot be empty</p>
                                )}
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputIC" className="formLabel">IC Number</CFormLabel>
                                <CFormTextarea id="icNumber" value={ShelterData.icNumber} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="1"
                                />
                                {(!ShelterData.icNumber || !(/^\d{6}-\d{2}-\d{4}$/.test(ShelterData.icNumber))) && (
                                    <p className="errorMessage">IC Number must be in the format xxxxxx-xx-xxxx</p>
                                )}
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputEmail" className="formLabel">Email</CFormLabel>
                                <CFormTextarea type="email" id="inputEmail" value={ShelterData.email} onChange={handleChange}
                                    disabled readOnly className={isEditing ? "edit" : "no-border"} rows="1"
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputTelephone" className="formLabel">Telephone</CFormLabel>
                                <CFormTextarea id="phoneNumber" value={ShelterData.phoneNumber} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="1" />
                                {(!ShelterData.phoneNumber || !(/^\+601\d-\d{7,8}$/.test(ShelterData.phoneNumber))) && (
                                    <p className="errorMessage">Phone Number must be in the format +601x-xxxxxxx</p>
                                )}
                            </CCol>

                            <CCol md={6}>
                                <CFormLabel htmlFor="inputAddress" className="formLabel">Address</CFormLabel>
                                <CFormTextarea id="address" value={ShelterData.address} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="2" />
                                {!ShelterData.address && (
                                    <p className="errorMessage">Address cannot be empty</p>
                                )}
                            </CCol>

                            <CCol md={4}>
                                <CFormLabel htmlFor="inputPostcode" className="formLabel">Postcode</CFormLabel>
                                <CFormTextarea id="postcode" value={ShelterData.postcode} rows="1"
                                    maxLength={5} required
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                                        if (/^\d{0,5}$/.test(value)) {
                                            setShelterData(prev => ({ ...prev, postcode: value }));
                                        }
                                    }}
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} />
                                {(!ShelterData.postcode || (ShelterData?.postcode?.length < 5 && ShelterData?.postcode.length > 0)) && (
                                    <p className="errorMessage">Postcode must be exactly 5 digits</p>
                                )}
                            </CCol>

                            <CCol md={4}>
                                <CFormLabel htmlFor="inputCity" className="formLabel">City</CFormLabel>
                                <CFormTextarea id="city" value={ShelterData.city} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="1" />
                                {!ShelterData.city && (
                                    <p className="errorMessage">City cannot be empty</p>
                                )}
                            </CCol>
                            <CCol md={4}>
                                <CFormLabel htmlFor="inputState" className="formLabel">State</CFormLabel>
                                <CFormSelect id="state" value={ShelterData.state} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"}>
                                    {malaysiaStates.map(state => (
                                        <option key={state} value={state}>{state}</option>
                                    ))}
                                </CFormSelect>
                            </CCol>
                        </CForm>
                    </div>

                    {isEditing ? <button onClick={handleSave} className="profileBtn">Save</button>
                        : <button onClick={handleEdit} className="profileBtn">Edit</button>}
                </>
            }
        </div>
    );
}



export default ShelterProfile;